/**
 * Utility functions for managing project data
 */

/**
 * Converts project data to a JavaScript module format
 * @param {Array} projects - Array of project objects
 * @returns {string} - JavaScript module string
 */
export const projectsToModuleString = (projects) => {
  // Create a copy of projects to avoid mutating the original
  const processedProjects = projects.map(project => {
    // Clone the project and remove the id property as it's not needed in the export
    const { id, ...projectWithoutId } = { ...project };
    
    // If the screenshot is a data URL (from our local processing), 
    // we replace it with a placeholder in the exported file
    if (projectWithoutId.screenshot && projectWithoutId.screenshot.startsWith('data:')) {
      // For the export, we'll use a placeholder path that would match 
      // what would be created if the server were running
      const projectName = projectWithoutId.name.toLowerCase().replace(/\s+/g, '-');
      projectWithoutId.screenshot = `/images/${projectName}.jpg`;
    }
    
    return projectWithoutId;
  });
  
  // Create a string representation of the projects array
  const projectsString = JSON.stringify(processedProjects, null, 2)
    .replace(/"([^"]+)":/g, '$1:') // Remove quotes from property names
    .replace(/"([^"]+)"/g, "'$1'"); // Replace double quotes with single quotes for string values
  
  // Return the complete module string
  return `import logo from "../logo.svg";
const projects = ${projectsString};

export default projects;
`;
};

/**
 * Downloads a file with the given content
 * @param {string} content - File content
 * @param {string} filename - Name of the file to download
 * @param {string} contentType - MIME type of the file
 */
export const downloadFile = (content, filename, contentType) => {
  const blob = new Blob([content], { type: contentType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

/**
 * Exports projects data as a JavaScript module file
 * @param {Array} projects - Array of project objects
 */
export const exportProjectsAsModule = (projects) => {
  const moduleContent = projectsToModuleString(projects);
  downloadFile(moduleContent, 'project-data.js', 'text/javascript');
}; 